import React from 'react';
import { Box } from '@mui/material';

interface PageContainerProps {
  children: React.ReactNode;
}

export default function PageContainer({ children }: PageContainerProps) {
  return (
    <Box
      sx={{
        p: 3,
        height: '100%',
        overflow: 'auto',
      }}
    >
      {children}
    </Box>
  );
}
